export default __webpack_public_path__ + "static/media/turkishcitizenship.4d460b8e.jpg";